export default (function () {
  return {
    tcVariables: {
      foo: 'bar'
    }
  };
});